import React, {
  useContext,
  useEffect,
  useState
}                           from 'react';
import { useTranslation }   from 'react-i18next';
import Image                from '@material-ui/icons/Image';
import { historyPropType }  from '~/config/routerPropTypes';
import { toast }            from 'react-toastify';
import Request              from '~/providers/Request';
import TourImageContext     from './context';
import ModalDelete          from '~/components/ModalDelete';
import Paper                from '~/components/Paper';
import PaperButtons         from '~/components/PaperButtons';
import GridContainer        from '~/components/GridContainer';
import GridItem             from '~/components/GridItem';
import InputShow            from '~/components/InputShow';
import {
  newTourImage,
  editTourImage,
  tourImage
}                           from '~/config/routes';
import TourImageRecord      from '~/records/TourImageRecord';
import { AbilityContext }   from '~/contexts/Can';

const attrName = (attr) => TourImageRecord.hummanAttributeName(attr);

function ShowTourImage({ history }) {
  const { t } = useTranslation();
  const { id } = history.location.route.getParams();
  const [ record, setRecord] = useState(new TourImageRecord());
  const { records, addRecords } = useContext(TourImageContext);
  const [loading, setLoading] = useState(!records || !records[id]);
  const [modal, setModal] = useState(false);
  const ability = useContext(AbilityContext);

  useEffect(() => {
    if(records && records[id]){
      setRecord( record.updateAttributes(records[id]) );
    }
    setLoading(true);
    Request.get(`/admin/tour_images/${id}`, {})
      .then( response => {
        setLoading(false);
        addRecords({ data: [response.data] });
        setRecord( record.updateAttributes(response.data) );
      })
      .catch( e => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  async function handleDelete(){
    setLoading(true);
    Request.del(`/admin/tour_images/${id}`)
    .then(() => {
      toast.success(t('tourImage.extras.delete_toast'));
      history.push(tourImage.spec);
    })
    .catch(() => {
      setLoading(false);
      toast.error(t('tourImage.extras.delete_toast_fail'));
    });
    setModal(false);
  }

  function renderImage(){
    if(record.get('image'))
      return <img src={record.getImageUrl()} style={{maxWidth: 400}} />;
  }
  return (
    <>
      <Paper
        Icon={Image}
        iconColor="blue"
        title={t('TourImage')}
        loading={loading}
        actions={<PaperButtons
          id={id}
          setModal={ability.can('delete', 'TourImages') ? setModal : null}
          backRoute={tourImage}
          newRoute={ability.can('new', 'TourImages') ? newTourImage : null}
          editRoute={ability.can('edit', 'TourImages') ? editTourImage : null}
        />}
      >
        <GridContainer>
          <GridItem xs={12} md={6}>
            <InputShow
              label={attrName('name')}
              value={record.get('name')}
            />
          </GridItem>

          <GridItem xs={4} md={2}>
            <InputShow
              label={attrName('sorter')}
              value={record.get('sorter')}
            />
          </GridItem>
          <GridItem xs={1} md={1}>
            <InputShow
              label={attrName('is_active')}
              value={record.get('is_active')}
              type='boolean'
            />
          </GridItem>
          <GridItem xs={8} sm={10} md={8}>
            {renderImage()}
          </GridItem>
        </GridContainer>
        <ModalDelete
          modal={modal}
          onClose={() => {
            setModal(false);
          }}
          name={record.get('name')}
          id={record.get('id')}
          deleteAction={handleDelete}
        />
      </Paper>
    </>

  );
}

ShowTourImage.propTypes = {
  history: historyPropType,
};

export default ShowTourImage;
